/** Data dictionary: column text search typeahead suggestions start after 3 characters. */
export const COLUMN_FILTER_MIN_CHARS = 3;

/** Max typeahead rows shown in column filter dropdowns (list scrolls when taller). */
export const COLUMN_FILTER_SUGGESTION_LIMIT = 50;

/** Whether a text column filter value should be sent to list/search APIs (from the 1st character). */
export function shouldApplyTextColumnFilter(_value: string): boolean {
  return true;
}

/** DataTable date-range value (`YYYY-MM-DD` or `from|to`) → UTC day bounds for list APIs. */
export function dateRangeColumnFilterToBounds(value: string): { from?: string; to?: string } {
  const trimmed = value.trim();
  if (!trimmed) return {};

  const pipe = trimmed.indexOf('|');
  const fromRaw = (pipe >= 0 ? trimmed.slice(0, pipe) : trimmed).trim();
  const toRaw = (pipe >= 0 ? trimmed.slice(pipe + 1).trim() : fromRaw) || fromRaw;
  const from = fromRaw.slice(0, 10);
  const to = toRaw.slice(0, 10);
  const out: { from?: string; to?: string } = {};

  if (/^\d{4}-\d{2}-\d{2}$/.test(from)) out.from = `${from}T00:00:00.000Z`;
  if (/^\d{4}-\d{2}-\d{2}$/.test(to)) out.to = `${to}T23:59:59.999Z`;

  return out;
}

export function uniqueColumnSuggestions(
  values: string[],
  query: string,
  limit = COLUMN_FILTER_SUGGESTION_LIMIT,
): string[] {
  const q = query.trim().toLowerCase();
  if (q.length < COLUMN_FILTER_MIN_CHARS) return [];

  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of values) {
    const v = raw.trim();
    if (!v || v === '—') continue;
    if (!v.toLowerCase().includes(q)) continue;
    if (seen.has(v)) continue;
    seen.add(v);
    out.push(v);
    if (out.length >= limit) break;
  }
  return out;
}
